module.exports = __webpack_public_path__ + "img/r3.fc040b2f.jpg";